import script from "./ChatDetailFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatDetailFooter.vue?vue&type=script&setup=true&lang=js"

import "./ChatDetailFooter.vue?vue&type=style&index=0&id=280b6af6&lang=scss"

const __exports__ = script;

export default __exports__